export const DISTRIBS_LIST = 'DISTRIBS_LIST'
export const DISTRIBS_ADD = 'DISTRIBS_ADD'
export const DISTRIBS_UPDATE = 'DISTRIBS_UPDATE'
export const DISTRIBS_DELETE = 'DISTRIBS_DELETE'
export const DISTRIBS_SINGLE = 'DISTRIBS_SINGLE'
export const DISTRIBS_BY_COUNTRY = 'DISTRIBS_BY_COUNTRY'



// WEBPACK FOOTER //
// ./src/store/actions/distributors.js